<template>
  <div class="settlement-set">
    <div class="title-wrap">
      <span
        class="prev-page"
        @click="$router.push({ name: 'IncomeSettlement' })"
        >结算中心</span
      >

      <img
        class="icon-arrows"
        src="../../assets/images/icon_page_connector.png"
      />
      <span class="current-page">结算设置</span>
    </div>
    <div class="set-content">
      <PhoneForm v-if="$route.name == 'settlementSet'"> </PhoneForm>
      <router-view></router-view>
    </div>
  </div>
</template>

<script>
import PhoneForm from './components/resultSet/phoneForm';

export default {
  name: 'settlementSet',
  components: {
    PhoneForm,
  },
};
</script>

<style lang="scss" scoped>
$--color-primary: #fd9b21;

.settlement-set {
  .title-wrap {
    font-size: 24px;
    color: #595959;
    padding-bottom: 24px;
    border-bottom: 1px solid rgba(217, 217, 217, 1);
    margin-bottom: 24px;
    .icon-arrows {
      margin: 0 24px;
      color: #8c8c8c;
    }
    .prev-page {
      cursor: pointer;
    }
    .current-page {
      color: #8c8c8c;
    }
  }

  .set-content {
    font-size: 16px;
    margin-top: 49px;
    display: flex;
    flex-direction: column;
    justify-content: center;
  }
}
</style>
